import React, { useState, useEffect } from "react";
import { Col, Row, Form } from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import Spinner from 'react-bootstrap/Spinner';
import { onError } from "../libs/errorLib";
import { API } from 'aws-amplify';
import Plot from 'react-plotly.js';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Table from 'react-bootstrap/Table';
import "bootstrap/dist/css/bootstrap.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { startCase } from 'lodash';
import { myListTimeSeriess } from '../graphql/my.queries';


// custom data fetching/processing hook
// https://www.robinwieruch.de/react-hooks-fetch-data
const useRestApi = (Symbol, Frequency, CsvFile, RiskDriver, NextStepModel, EstimationApproach, FlexibleProbabilities,
    ProjectionPeriods, ProjectionScenarios) => {
  const [symbol, setSymbol] = useState(Symbol);
  const [frequency, setFrequency] = useState(Frequency);
  const [csvFile, setCsvFile] = useState(CsvFile);
  const [riskDriver, setRiskDriver] = useState(RiskDriver);
  const [nextStepModel, setNextStepModel] = useState(NextStepModel);
  const [estimationApproach, setEstimationApproach] = useState(EstimationApproach);
  const [flexibleProbabilities, setFlexibleProbabilities] = useState(FlexibleProbabilities);
  const [projectionPeriods, setProjectionPeriods] = useState(ProjectionPeriods);
  const [projectionScenarios, setProjectionScenarios] = useState(ProjectionScenarios);
  const [isComputing, setIsComputing] = useState(false);
  const [isError, setIsError] = useState(false);
  const [dataCols, setDataCols] = useState({});
  const [dataRows, setDataRows] = useState({});

  const apiName = 'restapimeucci';
  const path = '/data-process/projection';
  const myInit = { // OPTIONAL
    headers: {}, // OPTIONAL
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    queryStringParameters: { 
      symbol: symbol,
      csvFile: csvFile,
      riskDriver: riskDriver,
      nextStepModel: nextStepModel,
      estimationApproach: estimationApproach,
      flexibleProbabilities: flexibleProbabilities,
      projectionPeriods: projectionPeriods,
      projectionScenarios: projectionScenarios
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsError(false);
      setIsComputing(true);
 
      try {
        const response = await API.get(apiName, path, myInit);
        //console.log(response.data);
        //console.log(JSON.parse(response.data.output));
        setDataRows(JSON.parse(response.data.output));
        
        // reformat response.data.output to columns
        var date_arr = [];
        var value_arr = [];
        var riskDriver_arr = [];
        var invariant_arr = [];
        var flexProb_arr = [];

        JSON.parse(response.data.output).forEach((item) => {
          date_arr.push(item.Date);
          value_arr.push(item.Value);
          riskDriver_arr.push(item.RiskDriver);
          invariant_arr.push(item.Invariant);
          flexProb_arr.push(item.FlexibleProb);

        });


        var hist_rd_arr = response.data.hist_rd;
        var bin_edges_rd_arr = response.data.bin_edges_rd;
        var stats_rd = response.data.stats_rd;
        console.log(hist_rd_arr);
        console.log(bin_edges_rd_arr);
        console.log(stats_rd);

        //process equal weight probs
        var width_rd = Math.abs(bin_edges_rd_arr[0]- bin_edges_rd_arr[1]);
        let half_bin = width_rd/2;
        let bin_rd_midpoints = new Array(hist_rd_arr.length);
        for (let i = 0; i < hist_rd_arr.length; i++) {
          bin_rd_midpoints[i] = bin_edges_rd_arr[i] + half_bin;
        }
        //console.log(bin_ew_midpoints);
        var rd_widths = new Array(hist_rd_arr.length);
        rd_widths = rd_widths.fill(width_rd);
        console.log('rd freq: ' + hist_rd_arr);
        console.log('rd bin mid: ' + bin_rd_midpoints);
        console.log('rd width: ' + rd_widths);




        setDataCols({'Date': date_arr, 'Value': value_arr, 'RiskDriver': riskDriver_arr, 'Invariant': invariant_arr, 'FlexibleProb': flexProb_arr,
          'HistRD': hist_rd_arr,
          'BinMidsRD': bin_rd_midpoints, 'WidthsRD': rd_widths, 'StatsRD': stats_rd
        });

      } catch (error) {
        setIsError(true);
        onError(error);
      }
 
      setIsComputing(false);
    };

    //console.log('Trying fetch : symbol=' + symbol + ' riskDriver=' + riskDriver);
    if (symbol !== "" && riskDriver !== "" && nextStepModel !== "" && estimationApproach !== "" && flexibleProbabilities !== ""
        && projectionPeriods !== "" && projectionScenarios !== "")  {
      fetchData();
      //console.log('Fetch OK! ' + symbol + ' ' + riskDriver);
    }

  }, [symbol, riskDriver, nextStepModel, estimationApproach, flexibleProbabilities, projectionPeriods, projectionScenarios]);
 
  return [{ dataCols, dataRows, isComputing, isError }, setSymbol, setFrequency, setCsvFile, setRiskDriver, 
    setNextStepModel, setEstimationApproach, setFlexibleProbabilities, setProjectionPeriods, setProjectionScenarios];
};


export default function Projection() {
  const [isLoading, setIsLoading] = useState(true);
  const [timeSeriess, setTimeSeriess] = useState(null);
  const [symbol, setSymbol] = useState(null);
  const [frequency, setFrequency] = useState(null);
  const [csvFile, setCsvFile] = useState(null);
  const [riskDriver, setRiskDriver] = useState("");
  const [nextStepModel, setNextStepModel] = useState("");
  const [estimationApproach, setEstimationApproach] = useState("");
  const [flexibleProbabilities, setFlexibleProbabilities] = useState("");
  const [projectionPeriods, setProjectionPeriods] = useState("");
  const [projectionScenarios, setProjectionScenarios] = useState("");
  const [timeSeriesSelected, setTimeSeriesSelected] = useState(false);
  const [riskDriverSelected, setRiskDriverSelected] = useState(false);
  const [nextStepModelSelected, setNextStepModelSelected] = useState(false);
  const [estimationApproachSelected, setEstimationApproachSelected] = useState(false);
  const [flexibleProbabilitiesSelected, setFlexibleProbabilitiesSelected] = useState(false);
  const [projectionPeriodsSelected, setProjectionPeriodsSelected] = useState(false);
  const [projectionScenariosSelected, setProjectionScenariosSelected] = useState(false);

  const [{ dataCols, dataRows, isComputing, isError }, 
    setSymbolArg, setFrequencyArg, setCsvFileArg, setRiskDriverArg, setNextStepModelArg, setEstimationApproachArg, setFlexibleProbabilitiesArg,
    setProjectionPeriodsArg, setProjectionScenariosArg] = useRestApi(
      symbol, frequency, csvFile, riskDriver, nextStepModel, estimationApproach, flexibleProbabilities, projectionPeriods, projectionScenarios);

  useEffect(() => {
    // fetch async data within useEffect hook (not as separate function) otherwise big problems
    // https://blog.logrocket.com/usestate-vs-useref/
    const fetchData = async () => {
      try {
        const apiData = await API.graphql({ query: myListTimeSeriess });
        const tsFromApi = apiData.data.listTimeSeriess.items;
        await Promise.all(tsFromApi);
        setTimeSeriess(apiData.data.listTimeSeriess.items);
        //console.log('tsFromApi len = ' + tsFromApi.length);
        //for (const [key, value] of Object.entries(tsFromApi)) {
          //console.log(`${key}: ${value.symbol}|${value.frequency}|${value.csvFile}`);
        //} 
      } catch (error) {
        onError(error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  function handleInputChange(event) {
    // used for disabling submit button
    switch (event.target.id) {
      case "selectTimeSeries":
        setTimeSeriesSelected(true);
        break;
      case "selectRiskDriver":
        //setRiskDriver(event.target.value);
        setRiskDriverSelected(true);
        break;
      case "selectNextStepModel":
        setNextStepModelSelected(true);
        break;
      case "selectEstimationApproach":
        setEstimationApproachSelected(true);
        break;
      case "selectFlexibleProbabilities":
        setFlexibleProbabilitiesSelected(true);
        break;
     case "selectProjectionPeriods":
        setProjectionPeriodsSelected(true);
        break;
     case "selectProjectionScenarios":
        setProjectionScenariosSelected(true);
        break;
        
     default:
        console.log("No input change.");
        break;
    }
    console.log("Input changed: " + event.target.id + " - " + event.target.value);
  }

  function validateForm() {
    // disables submit button if inputs not selected
    return (timeSeriesSelected) && (riskDriverSelected) && (nextStepModelSelected) && 
        (estimationApproachSelected) && (flexibleProbabilitiesSelected) &&
        (projectionPeriodsSelected) && (projectionScenariosSelected);
  }

  function handleSubmit(event) {
    let timeSeriesParams = document.getElementById('selectTimeSeries').value.split("|");
    setSymbol(timeSeriesParams[0]);
    setFrequency(timeSeriesParams[1]);
    setCsvFile(timeSeriesParams[2]);
    setSymbolArg(timeSeriesParams[0]);
    setFrequencyArg(timeSeriesParams[1]);
    setCsvFileArg(timeSeriesParams[2]);
    setRiskDriver(document.getElementById('selectRiskDriver').value);
    setRiskDriverArg(document.getElementById('selectRiskDriver').value);
    setNextStepModel(document.getElementById('selectNextStepModel').value);
    setNextStepModelArg(document.getElementById('selectNextStepModel').value);
    setEstimationApproach(document.getElementById('selectEstimationApproach').value);
    setEstimationApproachArg(document.getElementById('selectEstimationApproach').value);
    setFlexibleProbabilities(document.getElementById('selectFlexibleProbabilities').value);
    setFlexibleProbabilitiesArg(document.getElementById('selectFlexibleProbabilities').value);
    setProjectionPeriods(document.getElementById('selectProjectionPeriods').value);
    setProjectionPeriodsArg(document.getElementById('selectProjectionPeriods').value);
    setProjectionScenarios(document.getElementById('selectProjectionScenarios').value);
    setProjectionScenariosArg(document.getElementById('selectProjectionScenarios').value);
    event.preventDefault();
  }

  function ControlledTabs(props) {
    return (
      
      <div style={{display: 'block', width: '100%'}}>
        <Tabs defaultActiveKey="chart">
          <Tab eventKey="chart" title="Chart">
            <br />
            <QuestCharts dataCols={props.dataCols}/>
          </Tab>
          <Tab eventKey="data" title="Data">
            <br />
            <DataTable dataRows={props.dataRows}/>
          </Tab>
          <Tab eventKey="desc" title="Description">
            <br />  
            <Table size="sm" className="table table-borderless">
              <tbody>
                <tr>
                  <td className="col-md-3"><strong>Symbol:</strong></td>
                  <td className="col-md-9">{props.symbol}</td>
                </tr>
                <tr>
                  <td className="col-md-3"><strong>Frequency:</strong></td>
                  <td className="col-md-9">{startCase(props.frequency)}</td>
                </tr>
                <tr>
                  <td className="col-md-3"><strong>Data File:</strong></td>
                  <td className="col-md-9">{props.csvFile}</td>
                </tr>
                <tr>
                  <td className="col-md-3"><strong>Risk Driver:</strong></td>
                  <td className="col-md-9">{startCase(props.riskDriver)}</td>
                </tr>
                <tr>
                  <td className="col-md-3"><strong>Next Step Model:</strong></td>
                  <td className="col-md-9">{startCase(props.nextStepModel)}</td>
                </tr>
                <tr>
                  <td className="col-md-3"><strong>Estimation Approach:</strong></td>
                  <td className="col-md-9">{startCase(props.estimationApproach)}</td>
                </tr>
                <tr>
                  <td className="col-md-3"><strong>Flexible Probabilities:</strong></td>
                  <td className="col-md-9">{startCase(props.flexibleProbabilities)}</td>
                </tr>
                <tr>
                  <td className="col-md-3"><strong>Projection Periods:</strong></td>
                  <td className="col-md-9">{startCase(props.projectionPeriods)}</td>
                </tr>
                <tr>
                  <td className="col-md-3"><strong>Projection Scenarios:</strong></td>
                  <td className="col-md-9">{startCase(props.projectionScenarios)}</td>
                </tr>
                <tr>
                  <td className="col-md-3"><strong>Summary:</strong></td>
                  <td className="col-md-9">
                  Data has {props.dataCols.Date.length} rows and 5 columns:<br />
                    <ul>
                      <li>Date</li>
                      <li>Value</li>
                      <li>Risk Driver</li>
                      <li>Invariant</li>
                      <li>Flexible Prob</li>
                    </ul>                
                  </td>
                </tr>
              </tbody>
            </Table>
          </Tab>
        </Tabs>
      </div>
    );
  }
  
  function QuestCharts(props) {
    // https://codepen.io/plotly/pen/KpLVzv


/*     [
      '#1f77b4',  # muted blue
      '#ff7f0e',  # safety orange
      '#2ca02c',  # cooked asparagus green
      '#d62728',  # brick red
      '#9467bd',  # muted purple
      '#8c564b',  # chestnut brown
      '#e377c2',  # raspberry yogurt pink
      '#7f7f7f',  # middle gray
      '#bcbd22',  # curry yellow-green
      '#17becf'   # blue-teal
  ] */
 
/*     var trace0 = {
      type: 'bar',
      x: props.dataCols.BinMidsEW,
      y: props.dataCols.HistEW,
      width: props.dataCols.WidthsEW,
      offset: -props.dataCols.WidthsEW[0]/2
    }
    
    var trace4 = {
      type: 'bar',
      x: props.dataCols.BinMidsED,
      y: props.dataCols.HistED,
      width: props.dataCols.WidthsED,
      offset: -props.dataCols.WidthsED[0]/2
    } */
    
/*    var trace1 = {
      x: props.dataCols.Date,
      y: props.dataCols.EqualWeightProb,
      name: "Equal weight probs",
      type: "line",
      mode: 'lines',
      marker: {color: '#1f77b4'}, //muted blue
    };
    var trace2 = {
      x: props.dataCols.Date,
      y: props.dataCols.ExponentialDecayProb,
      name: "Exp. decay probs",
      type: "line",
      mode: 'lines',
      marker: {color: '#ff7f0e'},
    };
     var trace3 = {
      x: props.dataCols.Invariant,
      name: "Invariant",
      type: "histogram",
      marker: {
        color: '#1f77b4', // safety orange
      },
      histnorm: 'probability',
      xbins: {
        start: -0.203419135315326,
        end: 0.12025064,
        size: 0.03236697709969111
      }
    }; */

  
    var trace0 = {
      type: 'bar',
      x: props.dataCols.BinMidsRD,
      y: props.dataCols.HistRD,
      width: props.dataCols.WidthsRD,
      offset: -props.dataCols.WidthsRD[0]/2
    } 

    return (
      <>
      <div>
        <Plot
            data={[trace0]}
            config={ {responsive: true} }
            layout={ {title: symbol + ' Projected Risk Driver Distribution',
                      showlegend: false,

            } }
          />    
          <p>Mean: {Number.parseFloat(props.dataCols.StatsRD[0]).toFixed(6)}<br />
          Std: {Number.parseFloat(props.dataCols.StatsRD[1]).toFixed(6)}</p> 

      </div>


{/*       <div>
        <Plot
          data={[
            {
              x: props.dataCols.Date,
              y: props.dataCols.ExponentialDecayProb,
              type: 'line',
              mode: 'markers',
              //color: props.dataCols.ExponentialDecayProb,
              //marker: {color: 'Orange'},
              marker: {
                size: 4,
                cmax: 0.02,
                cmin: 0,
                color: props.dataCols.ExponentialDecayProb,
                colorbar: {
                  title: "Colorbar"
                },
                colorscale: "Viridis" //"RdBu"
              },
            },
          ]}
          config={ {responsive: true} }
          layout={ {title: symbol + ' Exponential Decay Time Conditioned Probabilities',
          } }
        /> 
      </div>

      <div>
        <Plot
          data={[
            {
              x: props.dataCols.Date,
              y: props.dataCols.Invariant,
              type: 'line',
              mode: 'markers',
              marker: {
                size: 5,
                cmax: 0.02,
                cmin: 0,
                color: props.dataCols.ExponentialDecayProb,
                colorscale: "Viridis"
              },
            },
          ]}
          config={ {responsive: true} }
          layout={ {title: symbol + ' Invariants'
          } }
        /> 
      </div>

      <div>
        <Plot
            data={[trace4]}
            config={ {responsive: true} }
            layout={ {title: 'Distribution of Invariants with Exponential Decay Probs',
                      showlegend: false,

            } }
          />    
          <p>Mean: {Number.parseFloat(props.dataCols.StatsED[0]).toFixed(6)}<br />
          Std: {Number.parseFloat(props.dataCols.StatsED[1]).toFixed(6)}</p> 

      </div>
      <hr className="featurette-divider" />
      <div>
        <Plot
          data={[
            {
              x: props.dataCols.Date,
              y: props.dataCols.EqualWeightProb,
              type: 'scatter',
              mode: 'markers',
              marker: {
                size: 4,
                cmax: 0.02,
                cmin: 0,
                color: props.dataCols.EqualWeightProb,
                colorbar: {
                  title: "Colorbar"
                },
                colorscale: "Viridis", //"RdBu",
              },
            },
          ]}
          config={ {responsive: true} }
          layout={ {title: symbol + ' Equal Weight Probabilities',
            xaxis: {range: [0.9*Math.min(props.dataCols.EqualWeightProb), 1.1*Math.max(props.dataCols.EqualWeightProb)]}
          } }
        /> 
      </div>

      <div>
        <Plot
          data={[
            {
              x: props.dataCols.Date,
              y: props.dataCols.Invariant,
              type: 'line',
              mode: 'markers',
              marker: {
                size: 5,
                cmax: 0.02,
                cmin: 0,
                color: props.dataCols.EqualWeightProb,
                colorscale: "Viridis"
              },
            },
          ]}
          config={ {responsive: true} }
          layout={ {title: symbol + ' Invariants'
          } }
        /> 
      </div>

      <div>
        <Plot
            data={[trace0]}
            config={ {responsive: true} }
            layout={ {title: 'Distribution of Invariants with Equal Weight Probs',
                      showlegend: false,

            } }
          />  
          <p>Mean: {Number.parseFloat(props.dataCols.StatsEW[0]).toFixed(6)}<br />
          Std: {Number.parseFloat(props.dataCols.StatsEW[1]).toFixed(6)}</p> 
      
      </div> */}


{/*       <div>
        <Plot
            data={[trace1, trace2]}
            config={ {responsive: true} }
            layout={ {title: 'Equal Weight and Exponential Decay Time Conditioned Probabilities',
                      showlegend: true,
                      xaxis: {
                        zeroline: false,
                        showline: false,
                        showgrid: true,
                      },
            } }
          />        
      </div>
      <hr className="featurette-divider" /> */}
      </>
    );  
  }
  
  function DataTable(props) {
    // data must be in rows
    //console.log('test dt: ' + props.dataRows);
    const dataTableColumns = [
      {
        dataField: "Date",
        text: "Date",
        sort: true
      },
      {
        dataField: "Value",
        text: "Value",
      },
      {
        dataField: "RiskDriver",
        text: "Risk Driver"
      },
      {
        dataField: "Invariant",
        text: "Invariant"
      },     
      {
        dataField: "FlexibleProb",
        text: "Flexible Prob"
      } 
    ];
    return (
      <div>
        <BootstrapTable
          bootstrap4
          keyField="Date"
          data={props.dataRows}
          columns={dataTableColumns}
          pagination={paginationFactory({ sizePerPage: 100 })}
          striped
          hover
          condensed
        />
      </div>
    );
  }


  return (
    <main className="flex-shrink-0">
      <div className="container">
        <h4 className="mt-3">Projection</h4>
        <br />
        <div className="container">
          <div className="row">
            {isError && <div>Error occurred [useRestApi function?] ...</div>}
            <div className="col-3">
              { isLoading ? (
                <Spinner animation="border" style={{color: "#990000"}}/>
                ) : (
                <>
                <div className="card">
                  <div className="card-body">
                    <Form onSubmit={handleSubmit}>
                      <Row>
                        <Form.Group as={Col} size="lg" controlId="selectTimeSeries">
                          <Form.Label>Time series:</Form.Label>
                          <Form.Control as="select" onChange={handleInputChange}>
                            <option value="" key="0">Select time series...</option>
                            {
                              Object.entries(timeSeriess).map(([key, value], index) => {
                                return(
                                  <option key={key+1} value={value.symbol + '|' + value.frequency + '|' + value.csvFile} data-type="text">{value.symbol}_{value.frequency}</option>
                                )
                              })
                            }                                
                          </Form.Control>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group as={Col} size="lg" controlId="selectRiskDriver">
                          <Form.Label>Risk Driver:</Form.Label>
                          <Form.Control as="select" onChange={handleInputChange}>
                            <option value="">Select risk driver...</option>
                            <option value="value">Value</option>
                            <option value="logValue">Log Value</option>
                          </Form.Control>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group as={Col} size="lg" controlId="selectNextStepModel">
                          <Form.Label>Next Step Model:</Form.Label>
                          <Form.Control as="select" onChange={handleInputChange}>
                            <option value="">Select next step model...</option>
                            <option value="randomWalk">Random Walk</option>
                            <option value="Garch11">GARCH(1,1)</option>
                          </Form.Control>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group as={Col} size="lg" controlId="selectEstimationApproach">
                          <Form.Label>Estimation Approach:</Form.Label>
                          <Form.Control as="select" onChange={handleInputChange}>
                            <option value="">Select estimation approach...</option>
                            <option value="historical">Historical with Flexible Probabilities</option>
                            <option value="copulaMarginal" disabled>Copula-Marginal</option>
                          </Form.Control>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group as={Col} size="lg" controlId="selectFlexibleProbabilities">
                          <Form.Label>Historical Flexible Probs:</Form.Label>
                          <Form.Control as="select" onChange={handleInputChange}>
                            <option value="">Select HFP...</option>
                            <option value="equalWeight">Equal Weight</option>
                            <option value="expDecay">Exponential Decay</option>
                          </Form.Control>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group as={Col} size="lg" controlId="selectProjectionPeriods">
                          <Form.Label>Projection Periods:</Form.Label>
                          <Form.Control as="select" onChange={handleInputChange}>
                            <option value="">Select periods...</option>
                            <option value="12">12</option>
                            <option value="24">24</option>
                            <option value="36">36</option>
                            <option value="60">60</option>
                            <option value="120">120</option>
                            <option value="240">240</option>
                          </Form.Control>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group as={Col} size="lg" controlId="selectProjectionScenarios">
                          <Form.Label>Projection Scenarios:</Form.Label>
                          <Form.Control as="select" onChange={handleInputChange}>
                            <option value="">Select scenarios...</option>
                            <option value="1000">1000</option>
                            <option value="10000">10000</option>
                          </Form.Control>
                        </Form.Group>
                      </Row>

                      <Row>
                        <Form.Group as={Col} size="lg" controlId="buttonSubmit">
                          <LoaderButton
                            size="md"
                            type="submit"
                            isLoading={isComputing}
                            disabled={!validateForm()}
                          >
                            Project
                          </LoaderButton>
                        </Form.Group>
                      </Row>
                    </Form>
                  </div>
                </div>
                </>
                )
              }
            </div>
            <div className="col-9">
              { !isComputing && Object.keys(dataCols).length > 0 &&
                <ControlledTabs dataCols={dataCols} dataRows={dataRows} symbol={symbol} frequency={frequency} csvFile={csvFile} 
                riskDriver={riskDriver} nextStepModel={nextStepModel} estimationApproach={estimationApproach} flexibleProbabilities={flexibleProbabilities}
                projectionPeriods={projectionPeriods} projectionScenarios={projectionScenarios}/>
              } 
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}